import { render, staticRenderFns } from "./NominationSummaryCard.vue?vue&type=template&id=a0e8f0d8&scoped=true"
import script from "./NominationSummaryCard.vue?vue&type=script&lang=js"
export * from "./NominationSummaryCard.vue?vue&type=script&lang=js"
import style0 from "./NominationSummaryCard.vue?vue&type=style&index=0&id=a0e8f0d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e8f0d8",
  null
  
)

export default component.exports